(function(window, app, overwatch, $, _) {
    var career = {
        currentComparisonKey: 0, //a simple array index for now
        modes: ["quickplay","competitive"],
        sections: ["highlights","heroComparison","stats"],
        init: function(bnetAccountId, platform, region) {
            //this.data = window.clientVars.careerData;
            this.bnetAccountId = bnetAccountId;
            this.platform = platform;
            this.region = region;

            this.setupDropdowns();
            this.setupHeroListToggle();
            this.setupProfileModes();
            this.getPlatformProfiles();
            overwatch.tooltip.init();
        },
        setupDropdowns: function() {
            //TODO: this should only work this way for achievement cards going forward
            var self = this,
                $selects = $("[data-js=career-select]");

            // reset select dropdown initial selection
            $selects.each(function() {
                $(this).prop('selectedIndex', 0);
            });

            $selects.on('change', function(e) {
                var $this = $(this);
                var categoryId = $this.val();
                var groupId = $this.data('groupId');
                var careerContainers = null;
                var option = null;
                // all the display-toggleable career sections (for the specified group id).
                if (groupId === "achievements") {
                    //context isn't necessary since there is only one achievements section
                    careerContainers = $('.toggle-display[data-group-id="' + groupId + '"]');
                } else {
                    // pass the context of the mode container that is currently shown
                    careerContainers = $('.toggle-display[data-group-id="' + groupId + '"]', $("#"+self.currentMode));
                }
                // hide all the career section (for the specified group id)
                careerContainers.removeClass('is-active');

                // show the newly selected career section
                careerContainers.filter('[data-category-id="' + categoryId + '"]').addClass('is-active');
                if(groupId === "stats") {
                    //when the stats category is changed, reinitialize the masonry layout
                    self.initializeStatsMasonry();
                }

                // Track career dropdown analytics
                option = $this.children('option').filter(':selected').attr('option-id');
                if(window.dataLayer) {
                    window.dataLayer.push({
                        'career.mode': self.currentMode,
                        'career.group': groupId,
                        'career.option': option,
                        'event': 'careerDropdown'
                    });
                }
            });

            $selects.dropdown();
        },
        setupHeroListToggle:function() {
            $(".js-show-more-heroes").on("click", function() {
                var $this = $(this),
                    categories = $this.siblings(".progress-category"),
                    oldLabel = '';
                if($this.data("showMore")) {
                    categories.removeClass("is-partial");
                    $this.data("showMore", false);
                } else {
                    categories.addClass("is-partial");
                    $this.data("showMore", true);
                }
                oldLabel = $this.text();
                $this.text($this.data("label"));
                $this.data("label", oldLabel);
                $(this).blur();
            });
        },
        setupProfileModes:function() {
            var self = this,
                $gameModes = $('#profile-btn-switcher a'),
                $heroImageElement = $('[data-js="heroMastheadImage"]');

            this.$modes = $();
            for(var i=0,len=this.modes.length; i<len; i++) {
                this.$modes = this.$modes.add($("#"+this.modes[i]));
            }

            function changeMode() {
                self.$modes.hide();
                $("#"+self.currentMode).show();
                $heroImageElement.removeClass(self.previousMode);
                $heroImageElement.addClass(self.currentMode);
                self.initializeStatsMasonry();
            }

            $(document.body).on("mode-change", function(event) {
                changeMode();

                // Track career tab switch analytics
                if(window.dataLayer) {
                    window.dataLayer.push({
                        'career.mode': self.currentMode,
                        'event': 'careerTabSwitch'
                    });
                }
            });

            this.currentMode = this.modes[0];
            this.previousMode = this.modes[0];

            // required for page initialization
            changeMode();

            $gameModes.on('click', function(e) {
                var $this = $(this),
                    mode = "";
                $gameModes.removeClass('is-active');
                $this.addClass('is-active');

                self.previousMode = self.currentMode;
                self.currentMode = $this.data("mode");
                $(document.body).trigger("mode-change");
                return false;
            });
        },
        getPlatformProfiles:function() {
            var bnetAccountId = this.bnetAccountId;
            var platform = this.platform;
            var region = this.region;
            //get the profiles for xbox and ps4 and display buttons to switch between platforms if you have them linked.
            var $profilePlatformsButtonContainer = $('#profile-platforms');
            var platformTemplate = _.template(document.getElementById('platform-btn-template').innerHTML);
            $.ajax('/'+clientVars.urlLocale+'/career/platforms/'+bnetAccountId).done(function(profiles) {
              var btnHtml = '';

              $.each(profiles, function(index, profile) {
                var className = '';
                if(profile.platform === platform) {
                  className = ' is-active';
                }

                btnHtml += platformTemplate({
                  'careerLink': '/'+clientVars.urlLocale+'/career/'+profile.platform+'/'+profile.urlName,
                  'platformName': profile.platform,
                  'classes': className
                });
              });

              $profilePlatformsButtonContainer.append(btnHtml);
            }).fail(function(err, results) {
                var btnHtml = platformTemplate({
                    'careerLink': window.location.href,
                    'platformName': platform,
                    'classes': ' is-active'
                });
                $profilePlatformsButtonContainer.append(btnHtml);
            }).always(function() {
                $profilePlatformsButtonContainer.removeClass('loading');
            });
        },
        initializeStatsMasonry: function() {
            //setup masonry effect for stats
            $('.js-stats:visible').masonry({
                itemSelector: '.column'
            });
        }
    };
    app.extend({ career: career });
}(window, window.app, window.overwatch, window.jQuery, window._));
